import GA4React from "ga-4-react";
import { useEffect, useState } from "react";
import api from "../Services/api";
import ErrorBoundary from "../ErrorHandler/ErrorBoundary";
import BannerSingle from "../BannerSingle";
import PageDescription from "../PageDescription";

const InfoComponent = (props: any) => {

  const [isloaded, setLoaded] = useState(false);
  const [result, setResult] = useState<any[]>([]);

  useEffect(() => {

    if (!isloaded) {

      setLoaded(true);

      api.get("/ObterLayoutPaginaFiltro?v=1&Identificador=" + props.page)
        .then((response) => {

          //somente para o mock
          var result = response.data.results.filter(function (r: any) { return r?.Identificador.toUpperCase() === props.page.toUpperCase(); });

          setResult(result);

          try {

            const ga4react = new GA4React(
              'G-47LVY79GP4',
              { /* ga custom config, optional */ },
              [ /* additional code, optional */],
              3000 /* timeout, optional, defaults is 5000 */,
              /* { nonce: ['first-script-is-async','second-script'] } */
            );
            ga4react.initialize().then((ga4) => {

              // console.log(decodeURIComponent(document.title));

              ga4.pageview(window.location.pathname + window.location.search, undefined, decodeURIComponent(document.title));

            }, (err) => {
              console.error(err)
            })

          } catch (err) {
            console.error(err);
          }

        })
        .catch((err) => {
          throw new Error(err);
        });

    }
  }, [isloaded, props.page]);

  useEffect(() => {
    if (result.length > 0) {
      document.title = result[0]?.Title;
    }
  }, [result]);

  return (
    <>
      <ErrorBoundary><BannerSingle image={props.image} page={props.page} items={result} /></ErrorBoundary>
      {/* Page description */}
      <ErrorBoundary><PageDescription page={props.page} items={result}/></ErrorBoundary>
    </>
  );
}
export default InfoComponent;
